import axios from "axios";
import {authHeader} from "../helpers/auth-header";

const getDropdownList = () => {
    return axios.get(`/api/rfid/getalltags`, { headers: authHeader() })
        .then((res) => { return res.data })
};

const getUnusedTags = () => {
    return axios.get(`/api/rfid/getUnusedTags`, { headers: authHeader() })
        .then((res) => { return res.data })
}

export const rfidService = {
    getDropdownList,
    getUnusedTags
}